<template>
  <pill :class="['badge', { clickable }]" :active="active" readonly>
    <icon v-if="icon" :class="['icon', { 'has-label': Boolean(label) }]" :name="icon" />
    <span v-if="label" class="label">{{ label }}</span>
  </pill>
</template>

<script>
import Icon from './Icon';
import Pill from './Pill';

export default {
  components: {
    Icon,
    Pill,
  },

  props: {
    icon: String,
    label: String,
    active: Boolean,
    clickable: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.badge {
  margin: 0;
  letter-spacing: 1px;
  font-size: 10px;
  margin-right: var(--badge-margin-right, $gp * .5);

  &.clickable:hover {
    cursor: pointer;
  }
}

.icon {
  font-size: 12px;

  &.has-label {
    margin-right: 4px;
  }
}

.label {
  text-transform: uppercase;
}
</style>
